import React, { useState } from "react";
import { Check } from "models/Check";
import { Alert } from "reactstrap";
import { Service } from "models/Service";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { editService } from 'store/actions/Services';
import { useOfficeTranslation } from 'i18n/OfficeTranslation';


interface Props {
    check: Check;
    service: Service;
    onCancel: () => void;
    save: () => void;
}

interface Actions {
    editService: (s: Service) => void;
    setChecks: (c: Check[]) => void;
}

const CheckServiceAdd: React.FC<Props & Actions> = ({ service, check, onCancel, save, editService, setChecks }) => {
    const { t } = useOfficeTranslation();

    const [error, setError] = useState<string | null>(null)

    const [name, setName] = useState<string>("")
    const [target, setTarget] = useState<string>("")
    const [type, setType] = useState<string>("")

    const saveCheck = () => {

        if (name === "" || target === "" || type === "") {
            setError(t("common.checkNeedsANameTargetAndType"))
        } else {

            check.name = name
            check.target = target
            check.type = type

            service.checks.push(check);

            editService(service)
                //@ts-ignore
                .then((service) => {
                    save();
                    setChecks(service.checks)
                })
        }
    }

    return (
        <>
            {
                error &&
                <Alert color="danger">{error}</Alert>
            }

            <br />

            <div className="form-floating mb-3">
                <button type="button"
                    onClick={() => {
                        onCancel();
                    }}
                    className="btn btn-danger waves-effect waves-light">
                    {t("common.cancel")}
                </button>
            </div>

            <div className="form-floating mb-3">
                <input type="text" name="nameperson" className="form-control" defaultValue={check.name} onInput={e => {
                    setName(e.currentTarget.value)
                }} placeholder={t("common.customer")} />
                <label className="">{t("common.name")}</label>
            </div>

            <div className="form-floating mb-3">
                <input type="text" name="roleperson" className="form-control" defaultValue={check.target} onInput={e => {
                    setTarget(e.currentTarget.value)
                }} placeholder={t("common.target")} />
                <label className="">{t("common.target")}</label>
            </div>

            <div className="form-floating mb-0">
                <h5 className="font-size-14 mb-2">{t("common.type")}</h5>
                <select className="form-select" style={{ paddingTop: "10px" }} value={check.type} onInput={e => {
                    setType(e.currentTarget.value)
                }} aria-label={t("common.type")}>
                    <option value="">{t("common.chooseOne")}</option>
                    <option value="http">{t("services.checkTypes.http")}</option>
                    <option value="ping">{t("services.checkTypes.ping")}</option>
                </select>

            </div>

            <div className="mt-3 mb-4">
                <button
                    id="buttonPerson"
                    name="buttonPerson"
                    type="button"
                    onClick={() => {
                        saveCheck()
                    }}
                    className="btn btn-primary w-100 waves-effect waves-light"
                >
                    {t("common.save")}
                </button>
            </div>
        </>
    );
};


const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators({ editService }, dispatch);
};

export default connect(null, mapDispatchToProps)(CheckServiceAdd);
